import { render } from "./bindView.vue?vue&type=template&id=b95fd27c&scoped=true"
import script from "./bindView.vue?vue&type=script&lang=js"
export * from "./bindView.vue?vue&type=script&lang=js"

import "./bindView.vue?vue&type=style&index=0&id=b95fd27c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95fd27c"]])

export default __exports__